var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 12.5219C20.5995 12.6961 17.9232 13.9021 15.9126 15.9126C13.9021 17.9232 12.6961 20.5995 12.5219 23.4375H12.4781C12.3042 20.5994 11.0983 17.9229 9.08773 15.9123C7.07712 13.9017 4.40061 12.6958 1.5625 12.5219V12.4781C4.40061 12.3042 7.07712 11.0983 9.08773 9.08773C11.0983 7.07712 12.3042 4.40061 12.4781 1.5625H12.5219C12.6961 4.40049 13.9021 7.07682 15.9126 9.08736C17.9232 11.0979 20.5995 12.3039 23.4375 12.4781V12.5219Z",
    fill: "#448AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.7ecd7693d2bca9b4d7026e9e3518e866.svg";
export { ForwardRef as ReactComponent };